module.exports = __webpack_public_path__ + "img/BestOfQuarterIntermediateWebDesign.8c0bbdf1.jpg";